import { errorLog } from '@/utils/logger';
import loadJS from 'load-js';

function Conpass() {
  let loading;

  const preLoad = () => {
    loading = loadJS([
      {
        async: true,
        url: 'https://fast.conpass.io/5yAf6Gq_lOjO.js',
      },
    ]);
    return loading;
  };

  const runConpass = async ([userName, userEmail]) => {
    try {
      await loading;
      const { Conpass } = window;
      Conpass.init({
        name: userName,
        email: userEmail,
      });
      Conpass.startFlow('C4f3kEyGqBUF9');
    } catch (e) {
      errorLog('Conpass error:', e);
    }
  };

  return {
    init: runConpass,
    preLoad,
  };
}

export default Conpass();
